import { render } from "./volleyball.vue?vue&type=template&id=2f779663"
import script from "./volleyball.vue?vue&type=script&lang=js"
export * from "./volleyball.vue?vue&type=script&lang=js"
script.render = render

export default script